export default {
  blockchain_title_update_success: "Blockchain updated",
  blockchain_title_update_fail: "Blockchain error",
  blockchain_update_success: "Transaction saved successfully",
  blockchain_update_fail: "Failed to save transaction"
};
